import styles from './ModalContent.module.scss';

type Props = {
  /**
   * The content to render. Be sure to handle scrolling if your content
   * won't fit on small screens.
   */
  children: React.ReactNode;
  /**
   * The rendered close button provided by `Modal`.
   */
  closeButton?: React.ReactNode;
  /**
   * The maximum width of `ModalContent`. Any valid CSS value can be used.
   * Only strings are supported to avoid special handling for numbers, so
   * make sure to provide a unit such as `px`.
   */
  maxWidth?: string;
};

export const ModalContentHeader = (props: { children: React.ReactNode }) => {
  return (
    <header className={styles.modalContentHeader} data-zds>
      {props.children}
    </header>
  );
};

export const ModalContentBody = (props: {
  size?: 'small' | 'medium';
  children: React.ReactNode;
  scrollable?: boolean;
}) => {
  const { size = props.scrollable ? 'small' : 'medium' } = props;
  return (
    <div
      className={styles.modalContentBody}
      data-scrollable={props.scrollable === true ? '' : undefined}
      data-size={size}
      data-zds
    >
      <div
        className={styles.modalContentBodyInner}
        data-scrollable={props.scrollable === true ? '' : undefined}
        tabIndex={props.scrollable === true ? 0 : undefined}
        data-zds
      >
        {props.children}
      </div>
    </div>
  );
};

export const ModalContentFooter = (props: { children: React.ReactNode }) => {
  return (
    <footer className={styles.modalContentFooter}>{props.children}</footer>
  );
};

export const ModalContent = (props: Props) => {
  const style = {
    maxWidth: props.maxWidth,
  };
  return (
    <div className={styles.root} style={style} data-zds>
      {props.children}
      {props.closeButton && (
        <div className={styles.closeButton}>{props.closeButton}</div>
      )}
    </div>
  );
};
